import { adminHttpClient } from '../commons/adminHttpClient'

export type EditCustomCategoryRequest = {
  name: string
  customCategoryId: number
  productClassId: string
}

const editCustomCategory = (values: EditCustomCategoryRequest): Promise<string> => {
  return adminHttpClient.post('Expenses/CustomCategory', values)
}

export default editCustomCategory
